import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROLE_LABELS } from '../utils/roles';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, role, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">جاري التحميل...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return (
      <div className="access-denied-page">
        <div className="access-denied-card">
          <h1>لا تملك صلاحية الوصول</h1>
          <p>
            دورك الحالي: <strong>{ROLE_LABELS[role] || role}</strong>
          </p>
          <p>هذه الصفحة متاحة فقط لأصحاب الصلاحيات المناسبة.</p>
          <Link to="/" className="btn btn-primary">العودة للرئيسية</Link>
        </div>
      </div>
    );
  }

  return children;
}
